import { FC } from "react";
import { DialogData, DialogHandle } from "../../types";
import { _, getZoneName } from "../../utils/helpers";
import { DEFAULT_DIALOG_HANDLE} from "../../utils/symbols";
import { SafeImage } from "../../parts/SafeImage";
import { Icon } from "../../parts/Icon";
import { useApp } from "../../context/useApp";

interface ZoneDialogProps {
    dialogData: DialogData
}

export const ZoneDialog: FC<ZoneDialogProps> = ({dialogData}) => {

    const {
        state: { dialogHandles, booking }
    } = useApp()

    if (dialogData.dialog !== 'zone' || dialogData.zone === null) return null

    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    return (
        <section 
            className={`df fd-c aifs jcfs r3 zone-${dialogData.zone} section p-r`}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <SafeImage src={dialogData.src} alt={dialogData.alt} className="img"/>
            <h2 id="dialog-title" className="text s18-500 p-5 cap white my-8 w-fc ml-8 zone-name r3">{`${getZoneName('long',dialogData.zone,booking.journey)}`}</h2>
            <p id="dialog-description" className="text s18-400 mb-8 px-8">{dialogData.description}</p>
            <button 
                className="button b-0 p-2 p-a zi-6 close df aic jcc"
                onClick={() => dialogHandle.closeDialog()}
            >
                <Icon icon="close"/>
            </button>
        </section>
    )
}